import React from "react";
import { translateService } from "../../services/imports";
import { LoadingButton } from "../../components/formcontrols/imports";

// The session could not start (share-prompt task 19), for both realms:
// userInfo, or the workspace or organization list, refused. The reason, then
// "Sign out" (that realm's Keycloak logout) or "Try again" (start the session
// again) - never a new login by itself.
export default function SessionError({ message, retrying, onRetry, onSignOut }) {
  const t = (k) => translateService.t(`session.${k}`);
  return (
    <div className={`link-page container ${translateService.key}`}>
      <div className="link-page__box" role="alert">
        <span className="title">{t("errorTitle")}</span>
        <p>{message || t("errorGeneric")}</p>
        <div className="buttons">
          <LoadingButton
            type="button"
            className="button background-color-two color-white"
            loading={retrying}
            onClick={onRetry}
          >
            {t("retry")}
          </LoadingButton>
          <LoadingButton type="button" className="button background-color-three color-white" onClick={onSignOut}>
            {t("signOut")}
          </LoadingButton>
        </div>
      </div>
    </div>
  );
}
